import { render, staticRenderFns } from "./IL.vue?vue&type=template&id=1a1e49ce&scoped=true"
import script from "./IL.vue?vue&type=script&lang=js"
export * from "./IL.vue?vue&type=script&lang=js"
import style0 from "./IL.vue?vue&type=style&index=0&id=1a1e49ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e49ce",
  null
  
)

export default component.exports